export const SubscriptionActionTypes = {
  // Fetch subscriptions
  GET_SUBSCRIPTIONS: "GET_SUBSCRIPTIONS",

  // Add subscription
  ADD_SUBSCRIPTION: "ADD_SUBSCRIPTION",

  // Update subscription
  UPDATE_SUBSCRIPTION: "UPDATE_SUBSCRIPTION",

  // Delete subscription
  DELETE_SUBSCRIPTION: "DELETE_SUBSCRIPTION",

  EDITING_PLAN: "EDITING_PLAN",
};
